<script setup lang="ts">
import FilterPopoverBase from '../modules/FilterPopoverBase.vue'
import FilterCheckboxes from './FilterCheckboxes.vue'
import FilterParkingCost from './FilterParkingCost.vue'
import { useFilterPopoverState } from '~/composables/filter/useFilterPopoverState'
import type { useFilterState } from '~/composables/filter/useFilterState'
import type {
  EstateListingEssentialResponse,
  EstateListingResponse,
} from '~/types/api/EstateListing'

defineProps<{
  officesResponse: EstateListingResponse | EstateListingEssentialResponse
  filterState: ReturnType<typeof useFilterState>
}>()

const filterPopoverState = useFilterPopoverState()
</script>

<template>
  <FilterPopoverBase :filter-popover-state="filterPopoverState">
    <template #trigger-value>{{ $t('filter.advancedFilters.title') }}</template>

    <template #popover-body>
      <div class="c-filter-advanced">
        <FilterParkingCost
          v-if="
            officesResponse.filter.parking_cost_from &&
            officesResponse.filter.parking_cost_to
          "
          :offices-response="officesResponse"
          :filter-state="filterState"
        />

        <FilterCheckboxes
          :offices-response="officesResponse"
          :filter-state="filterState"
        />
      </div>
    </template>
  </FilterPopoverBase>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-filter-advanced {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 10px;

  @include breakpoint-down('md') {
    gap: 0;
    margin-bottom: 0;

    & > *:not(:first-child) {
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid var(--color-border);
    }
  }
}
</style>
